import React, { useEffect, useRef, useState } from 'react';
import More from '../../svg/More';
import { getContrastColor, maxLength } from '../DizeeComponent/DixeeInput2';
import CusCardMusic from '../CusCardMusic';
import { getAccentLightStyle, getAccentStyle, haxToRgbLight } from '../../constants/constants';
import CrossArrow from '../../svg/CrossArrow';

export default function Custom(props) {
    let { userArticle, custom, setOverlay } = props;
    console.log(`custom::`, custom);
    console.log('Custom component received:', custom);

    // Filter for only published items
    // const publishedCustom = custom?.filter(m => m?.publish?.value === 'publish');

    const containerRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const videoItems = custom.filter(o => o.type === 'video');

    useEffect(() => {
        const container = containerRef.current;

        const handleScroll = () => {
            const scrollLeft = container.scrollLeft;
            const itemWidth = 318 + 16; // item width + gap
            const index = Math.round(scrollLeft / itemWidth);
            setCurrentIndex(index);
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className='flex flex-col justify-start items-center w-full'>
            <>
                {custom.filter(o => o.type == 'music').length > 0 &&
                    <div className="text-[#FDFAFA] my-4 flex w-full px-4 flex-row justify-between items-center">
                        <div>
                            <p className="mr-2" style={userArticle?.accent ? { color: `#${userArticle?.accent}` } : { color: '#ffffff' }}>
                                {`CUSTOM MUSIC`}
                            </p>
                        </div>
                        <More className='h-[20px] w-[20px] cursor-pointer' color={getContrastColor(userArticle?.background) ? `#${getContrastColor(userArticle?.background)}` : '#ffffff'} onClick={() => setOverlay(true)} />
                    </div>
                }
                {custom.filter(o => o.type == 'music').length > 0 && (
                    <div className="w-full mb-[60px] overflow-x-auto px-4 flex flex-row gap-x-4">
                        {custom.filter(o => o.type == 'music').map((item, index) => (
                            <>
                                <div className="w-[130px] flex-shrink-0 flex flex-col h-auto">
                                    <img
                                        onClick={() => window.open(item.link, "_blank")}
                                        src={item.avatar}
                                        alt="imageurl"
                                        className="h-[130px] object-cover w-[130px] cursor-pointer rounded-[3px]"
                                    />
                                    <div className="w-full pt-3 justify-center flex flex-col items-center gap-y-1">
                                        <p className="text-white w-full text-[12px]" style={getAccentStyle(userArticle?.accent)}>
                                            {maxLength(item.sectionTitle, 15)}
                                        </p>
                                        <p className="text-gray-300 w-full text-[12px]" style={getAccentLightStyle(haxToRgbLight(userArticle?.accent))}>
                                            {maxLength(item.primaryText, 15)}
                                        </p>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                )}
            </>


            <>
                {custom.filter(o => o.type == 'video').length > 0 &&
                    <div className="text-[#FDFAFA] my-4 flex w-full px-4 flex-row justify-between items-center">
                        <div>
                            <p className="mr-2" style={userArticle?.accent ? { color: `#${userArticle?.accent}` } : { color: '#ffffff' }}>
                                {`CUSTOM VIDEO`}
                            </p>
                        </div>
                        <More className='h-[20px] w-[20px] cursor-pointer' color={getContrastColor(userArticle?.background) ? `#${getContrastColor(userArticle?.background)}` : '#ffffff'} onClick={() => setOverlay(true)} />
                    </div>
                }

                <div className="w-full px-4 relative">
                    {/* Video Scroll Area */}
                    <div
                        ref={containerRef}
                        className="w-full mb-[60px] overflow-x-auto flex flex-row gap-x-4 scroll-smooth"
                    >
                        {videoItems.map((item, index) => (
                            <div key={index} className="w-[318px] flex-shrink-0 flex flex-col h-auto">
                                <div className="relative cursor-pointer" onClick={() => { }}>
                                    <div className="w-full rounded-[3px] overflow-hidden">
                                        <img
                                            src={item.avatar}
                                            alt="imageurl"
                                            className="w-full h-[600px] object-cover"
                                        />
                                    </div>
                                </div>

                                <div className="w-full pt-3">
                                    <p
                                        className="text-[12px]"
                                        style={getAccentStyle(userArticle?.accent)}
                                    >
                                        {maxLength(item.sectionTitle, 15)}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Dots Positioned Absolutely Inside Scroll Area */}
                    {
                        videoItems.length > 1 &&
                        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-x-2 z-10">
                            {videoItems.map((_, index) => (
                                <div
                                    key={index}
                                    className={`w-[6px] h-[6px] rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-white' : 'bg-gray-400'}`}
                                />
                            ))}
                        </div>
                    }
                </div>
            </>


            <>
                {custom.filter(o => o.type == 'event').length > 0 &&
                    <div className="text-[#FDFAFA] my-4 flex w-full px-4 flex-row justify-between items-center">
                        <div>
                            <p className="mr-2" style={userArticle?.accent ? { color: `#${userArticle?.accent}` } : { color: '#ffffff' }}>
                                {`CUSTOM EVENT`}
                            </p>
                        </div>
                        <More className='h-[20px] w-[20px] cursor-pointer' color={getContrastColor(userArticle?.background) ? `#${getContrastColor(userArticle?.background)}` : '#ffffff'} onClick={() => setOverlay(true)} />
                    </div>
                }
                {custom.filter(o => o.type == 'event').length > 0 && (
                    <div className="w-full mb-[60px] px-4 flex flex-row gap-x-4w-full flex flex-col justify-center items-center gap-y-[16px] mt-4 mb-[60px]">
                        {custom.filter(o => o.type == 'event').map((item, index) => (
                            <React.Fragment key={index}>
                                <div className='flex w-full items-center px-2'>
                                    <div className='grid w-full gap-2' style={{
                                        gridTemplateColumns: '70px 1.4fr 0.6fr'
                                    }}>
                                        {/* Day of week */}
                                        <div className='text-white truncate pl-1' style={{ color: `#${userArticle.accent}` }}>
                                            {item?.date.split(',')[0]}
                                        </div>

                                        {/* Location - with strict width control and proper accent color */}
                                        <div style={{
                                            width: '100%',
                                            minWidth: 0,
                                            position: 'relative',
                                            paddingRight: '24px',
                                            overflow: 'hidden'
                                        }}>
                                            <div className='truncate pl-1' style={{
                                                maxWidth: '70%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: `#${userArticle.accent}`
                                            }}>
                                                {maxLength(item?.location, 35)}
                                            </div>
                                        </div>

                                        {/* Venue and arrow */}
                                        <div style={{
                                            width: '100%',
                                            position: 'relative'
                                        }}>
                                            <div className='flex justify-between items-center absolute' style={{
                                                left: '-80%',
                                                right: 0,
                                                top: 0,
                                                bottom: 0,
                                                zIndex: 1
                                            }}>
                                                <span className='truncate pl-1' style={{
                                                    color: `#${userArticle.accent}`,
                                                    width: 'calc(100% - 24px)',
                                                    minWidth: 0,
                                                    backgroundColor: `#${userArticle?.background}` || '#000'
                                                }}>
                                                    {maxLength(item?.venue, 15)}
                                                </span>
                                                <button
                                                    onClick={() => window.open(`${item.links[0]?.url}`, '_blank')}
                                                    className="flex items-center justify-center flex-shrink-0 w-6"
                                                >
                                                    <CrossArrow
                                                        className="h-[14px] w-[14px]"
                                                        color={`#${userArticle.accent}`}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-full mx-2'>
                                    <div className={`mx-2`} style={{
                                        borderBottom: `.3px solid #${userArticle.accent}`
                                    }}></div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                )}
            </>
            <>
                {custom.filter(o => o.type == 'product').length > 0 &&
                    <div className="text-[#FDFAFA] my-4 flex w-full px-4 flex-row justify-between items-center">
                        <div>
                            <p className="mr-2" style={userArticle?.accent ? { color: `#${userArticle?.accent}` } : { color: '#ffffff' }}>
                                {`CUSTOM PRODUCT`}
                            </p>
                        </div>
                        <More className='h-[20px] w-[20px] cursor-pointer' color={getContrastColor(userArticle?.background) ? `#${getContrastColor(userArticle?.background)}` : '#ffffff'} onClick={() => setOverlay(true)} />
                    </div>
                }
                {custom.filter(o => o.type == 'product').length > 0 && (
                    <div className="w-full mb-[60px] overflow-x-auto px-4 flex flex-row gap-x-4">
                        {custom.filter(o => o.type == 'product').map((item, index) => (
                            <>
                                <div className="w-[130px] flex-shrink-0 flex flex-col h-auto">
                                    <img
                                        onClick={() => window.open(item.link, "_blank")}
                                        src={item.avatar}
                                        alt="imageurl"
                                        className="h-[130px] object-cover w-[130px] cursor-pointer rounded-[3px]"
                                    />
                                    <div className="w-full pt-3 justify-center flex flex-col items-center gap-y-1">
                                        <p className="text-white w-full text-[12px]" style={getAccentStyle(userArticle?.accent)}>
                                            {maxLength(item.sectionTitle, 15)}
                                        </p>
                                        {/* <p className="text-gray-300 w-full text-[12px]" style={getAccentLightStyle(haxToRgbLight(userArticle?.accent))}>
                                            {maxLength(artist, 15)}
                                        </p> */}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                )}
            </>
            <>
                {custom.filter(o => o.type == 'social').length > 0 &&
                    <div className="text-[#FDFAFA] my-4 flex w-full px-4 flex-row justify-between items-center">
                        <div>
                            <p className="mr-2" style={userArticle?.accent ? { color: `#${userArticle?.accent}` } : { color: '#ffffff' }}>
                                {`CUSTOM SOCIAL`}
                            </p>
                        </div>
                        <More className='h-[20px] w-[20px] cursor-pointer' color={getContrastColor(userArticle?.background) ? `#${getContrastColor(userArticle?.background)}` : '#ffffff'} onClick={() => setOverlay(true)} />
                    </div>
                }
                {custom.filter(o => o.type == 'social').length > 0 && (
                    <div className="w-full mb-[60px] overflow-x-auto px-4 flex flex-row gap-x-4">
                        {custom.filter(o => o.type == 'social').map((item, index) => (
                            <>
                                <div className="w-[130px] flex-shrink-0 flex flex-col h-auto">
                                    <img
                                        onClick={() => window.open(item.link, "_blank")}
                                        src={item.avatar}
                                        alt="imageurl"
                                        className="h-[130px] object-cover w-[130px] cursor-pointer rounded-[3px]"
                                    />
                                    <div className="w-full pt-3 justify-center flex flex-col items-center gap-y-1">
                                        <p className="text-white w-full text-[12px]" style={getAccentStyle(userArticle?.accent)}>
                                            {maxLength(item.sectionTitle, 15)}
                                        </p>
                                        {/* <p className="text-gray-300 w-full text-[12px]" style={getAccentLightStyle(haxToRgbLight(userArticle?.accent))}>
                                            {maxLength(artist, 15)}
                                        </p> */}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                )}
            </>
        </div>
    );
}